import type { ConfirmDialogOptions } from '@/components/ui/ConfirmDialog/ConfirmDialog'
import { createContext, useContext } from 'react'

export type { ConfirmDialogContent, ConfirmDialogContentHelpers, ConfirmDialogOptions } from '@/components/ui/ConfirmDialog/ConfirmDialog'

interface ConfirmDialogContextType {
    confirm: (options: ConfirmDialogOptions) => void
}

export const ConfirmDialogContext = createContext<ConfirmDialogContextType | undefined>(undefined)

export const useConfirmDialog = (): ConfirmDialogContextType => {
    const context = useContext(ConfirmDialogContext)
    if (!context) {
        throw new Error('useConfirmDialog must be used within a ConfirmDialogProvider')
    }
    return context
}
